const routesCommonAuthenticated = {
  routes() {
    return [
      {
        path: "/profile",
        name: "profile",
        component: () => import("./views/common/profile/Profile.vue")
      },
      {
        path: "/missingPrincipalOwner",
        name: "missingPrincipalOwner",
        component: () => import("./views/MissingPrincipalOwner.vue")
      },
      {
        path: "/ccpr/myCompanyEarnings",
        name: "ccprMyCompanyEarnings",
        component: () => import("./views/ccpr/MyCompanyEarnings.vue"),
        meta: {
          participantTypes: ["100", "500", "600", "700", "800"]
        }
      }
    ];
  }
};

export default routesCommonAuthenticated;
